import { useDispatch } from "react-redux";
import { CircleQuestionRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const ListingInquiryActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={CircleQuestionRegularV6}>
            Listing Inquiry
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Address" data={activity.data?.propertyStreetAddress} />
        <DataField label="Question" data={activity.data.question} />
        <ActivityBtns
          callHandlr={() => {
            if (activity.personUuid) {
              dispatch(
                setCallParams({ leadUuids: [activity.personUuid], callSource: "Listing Inquiry Activity" }),
              );
            }
          }}
        />
      </div>
    </ActivityContainer>
  );
};

export default ListingInquiryActivity;

ListingInquiryActivity.propTypes = {
  ...activityCommonPropTypes,
};

ListingInquiryActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
